// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"44":"p__detail__index","89":"p__bulletin__index","717":"layouts__index"}[chunkId] || chunkId) + "." + {"44":"6ba8d005","89":"7416152d","390":"1cf5aeaa","717":"261218b6"}[chunkId] + ".async.js";
};